/** Report / chart / export palette, in brand order (fill then tint per hue). */
export const REPORT_COLORS = {
  green: "#007B63",
  greenTint: "#BAFFC5",
  slate: "#395878",
  slateTint: "#ABC7E5",
  taupe: "#6B635C",
  taupeTint: "#B8AEA5",
  gray: "#55585A",
  grayTint: "#C6C8C9",
  orange: "#F3864C",
  orangeTint: "#FFCFA7",
  charcoal: "#373330",
  charcoalTint: "#E0DBD4",
  teal: "#376B83",
  tealTint: "#95D7E2",
} as const;

export const CHART_SLICE_PALETTE = [
  REPORT_COLORS.green,
  REPORT_COLORS.greenTint,
  REPORT_COLORS.slate,
  REPORT_COLORS.slateTint,
  REPORT_COLORS.taupe,
  REPORT_COLORS.taupeTint,
  REPORT_COLORS.gray,
  REPORT_COLORS.grayTint,
  REPORT_COLORS.orange,
  REPORT_COLORS.orangeTint,
  REPORT_COLORS.charcoal,
  REPORT_COLORS.charcoalTint,
  REPORT_COLORS.teal,
  REPORT_COLORS.tealTint,
] as const;

export const CHART_SLICE_ANCHOR_COLOR = CHART_SLICE_PALETTE[0];

const GOLDEN_RATIO = 0.61803398875;

/** Golden-ratio hue steps for map pins (bright, full wheel). */
export function getGoldenRatioDistinctHsl(
  newValue: number,
  options?: { anchorHue?: number },
): { h: number; s: number; l: number } {
  const baseHue =
    options?.anchorHue !== undefined
      ? (options.anchorHue + newValue * GOLDEN_RATIO * 360) % 360
      : ((newValue + 50) * GOLDEN_RATIO * 360) % 360;

  const hueOffset = (newValue % 5) * 10;
  const hue = (baseHue + hueOffset) % 360;
  const saturation = 60 + (newValue % 3) * 10;
  const lightness = 50 + (newValue % 3) * 5;

  return { h: hue, s: saturation, l: lightness };
}

export function hslToCss({ h, s, l }: { h: number; s: number; l: number }): string {
  return `hsl(${h}, ${s}%, ${l}%)`;
}

export function getChartSliceColor(index: number): string {
  return CHART_SLICE_PALETTE[index % CHART_SLICE_PALETTE.length];
}
